module.exports = __webpack_public_path__ + "static/img/1-commitment-swear.884ec34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-commitment-swear.jpg
// module id = Iyc4
// module chunks = 1